module.exports = __webpack_public_path__ + "static/media/image3.a227a6c2.jpeg";